// extracted by mini-css-extract-plugin
export default {"productGrid":"z0-z","centerLink":"A0-z","productSection":"B0-z","item":"C0-z","ctaButton":"D0-z"};